import { Helpers } from '../../helpers';
import { IBatchProcessType } from '../../interfaces/ibatch-process-type';
import { DrillDesign } from '../drill-design';
import { DrillGroup } from '../drill-group';
import { ScenarioWell } from '../scenario-well';
import { ScheduleBuildSetting } from '../schedule-build-setting';

export class BatchProcessTypeBase {
  BatchProcessTypeId: number;
  Name: string;
  AssetTeamId: number;
  DrillDesignId: number;
  DateCreated: Date;
  CreatedByUID: string;
  BatchProcessCodeRelationshipsJSON: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  DrillGroups_BatchProcessType?: Array<DrillGroup> | null;
  ScenarioWells_BatchProcessType?: Array<ScenarioWell> | null;
  ScheduleBuildSettings_DefaultBatchProcessType?: Array<ScheduleBuildSetting> | null;
  DrillDesign?: DrillDesign;

  constructor(item?: IBatchProcessType) {
    if (item) {

      this.BatchProcessTypeId = item.BatchProcessTypeId;
      this.Name = item.Name;
      this.AssetTeamId = item.AssetTeamId;
      this.DrillDesignId = item.DrillDesignId;
      this.DateCreated = item.DateCreated ? new Date(item.DateCreated) : null;
      this.CreatedByUID = item.CreatedByUID;
      this.BatchProcessCodeRelationshipsJSON = item.BatchProcessCodeRelationshipsJSON;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.DrillGroups_BatchProcessType = Helpers.createClassArray(DrillGroup, item.DrillGroups_BatchProcessType);
      this.ScenarioWells_BatchProcessType = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_BatchProcessType);
      this.ScheduleBuildSettings_DefaultBatchProcessType = Helpers.createClassArray(ScheduleBuildSetting, item.ScheduleBuildSettings_DefaultBatchProcessType);
      this.DrillDesign = new DrillDesign(item.DrillDesign);
    }
  }
}